export const estilosProvNew = {
  10: {
    success: "#00C975",
    backgroundLight: "#fbeeff",
    primary: "#600080",
    secondary: "#600080",
    button: {
      primary: "#8a77b9",
      secondary: "#f2f2f2",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#b024de",
    hoverSecondary: "",
    gradiente1Llamador: "#600080",
    gradiente2Llamador: "#600080",
    fondoLlamador: "",
    info: {
      titulo: "Loteria de Tierra Del Fuego Online",
      shortName: "loteriadetierradelfuego",
      canonical: "https://loteriadetdf.bet.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "",
      numeroWhatsapp: "",
      mail: "",
      dias: "",
      juegoResponsable: "https://www.ipra.gov.ar/web/juegoresponsable/",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#8E80BF",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#D97C28",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  11: {
    success: "#00C975",
    backgroundLight: "#eaf3ff",
    primary: "#0046ac",
    secondary: "#0046ac",
    button: {
      primary: "",
      secondary: "",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#256cd3",
    hoverSecondary: "",
    gradiente1Llamador: "#edf1f5",
    gradiente2Llamador: "#edf1f5",
    fondoLlamador: "",
    info: {
      titulo: "Loteria de Santa Cruz Online",
      shortName: "loteriadesantacruz",
      canonical: "https://sc.lotline.com.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "Perito Moreno esquina Zapiola, Río Gallegos",
      numeroWhatsapp: "2966-631277",
      mail: "contacto@lotline.com.ar",
      dias: "Lunes a Viernes: 10:00hs a 20:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  12: {
    success: "#00C975",
    backgroundLight: "#fffbe9",
    primary: "#ffcc00",
    secondary: "#ffcc00",
    button: {
      primary: "#06C124",
      secondary: "#ffffff",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "#06C124",
        secondary: "#f1ecff",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#000000",
    textSecondary: "#000000",
    hoverPrimary: "#f7d341",
    hoverSecondary: "",
    gradiente1Llamador: "#ffeea1",
    gradiente2Llamador: "#2122411f",
    fondoLlamador: "#ffcc00",
    info: {
      titulo: "La Neuquina Online",
      shortName: "laneuquinaonline",
      canonical: "https://www.laneuquinaonline.com.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "Carlos H. Rodríguez 146, Neuquén",
      telefono: "299 4576784",
      mail: "contacto@laneuquinaonline.bet.ar",
      dias: "Lunes a Sábados: 08:00hs a 22:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        // Quiniela tradicional
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      1: {
        // Quiniela Instantánea
        colorFrom: "#ffcc00",
        colorTo: "#FFFFFF",
      },
      4: {
        // Quini 6
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      3: {
        // Loto Plus
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      6: {
        // Pozo de la Quiniela
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      10: {
        // Lotería Unificada
        colorFrom: "#ffcc00",
        colorTo: "#FFFFFF",
      },
      20: {
        // Patagonia Minibingo
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      21: {
        // Patagonia Telebingo
        colorFrom: "#ffcc00",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
    },
  },
  13: {
    success: "#00C975",
    backgroundLight: "#eefff6",
    primary: "#01c160",
    secondary: "#01c160",
    button: {
      primary: "",
      secondary: "",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#2bde84",
    hoverSecondary: "",
    gradiente1Llamador: "#aeaeef",
    gradiente2Llamador: "#5e5ef7",
    fondoLlamador: "#19193a",
    info: {
      titulo: "La Rionegrina Online",
      shortName: "larionegrinaonline",
      canonical: "https://www.loteriadesaltaonline.com.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion:
        "Sede Central: 25 de Mayo y Sarmiento (8500) - Viedma - Río Negro",
      numeroWhatsapp: "2920-487001",
      mail: "contacto@larionegrinaonline.com.ar",
      dias: "Lunes a Viernes: 10:00hs a 20:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  15: {
    success: "#00C975",
    backgroundLight: "#f2f7ff",
    primary: "#1C3257",
    secondary: "#90b228",
    button: {
      primary: "#90b228",
      secondary: "#fff",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#1C3257",
        secondary: "#1C3257",
        primary: "#fff",
      },
      hover: {
        primary: "#c2e84f",
        secondary: "#eeeded",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#3b69b8",
    hoverSecondary: "",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "",
    info: {
      titulo: "Loteria de Catamarca Online",
      shortName: "loteriadecatamarcaonline",
      canonical: "https://www.loteriadecatamarcaonline.bet.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "",
      numeroWhatsapp: "",
      telefono: "",
      mail: "",
      dias: "",
      diasFinde: "",
      juegoResponsable: "https://portal.catamarca.gob.ar/paginas/juego-responsable-524",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#A0BF53",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#1C3257",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  16: {
    success: "#00C975",
    backgroundLight: "#e9fff9",
    primary: "#27594B",
    secondary: "#1CA63F",
    button: {
      primary: "#b0d9ba",
      secondary: "#f4f0d8",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#27594B",
        primary: "#000000",
      },
      hover: {
        primary: "#1ca63f",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#38d35f",
    hoverSecondary: "",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "",
    info: {
      numeroWhatsapp: "",
      telefono: "0380-4427527",
      mail: "contacto@ajalar.bet.ar",
      dias: "Lunes a Viernes: 08:00hs a 13:00hs.",
      diasFinde: "",
      juegoResponsable: "https://ajalar.com.ar/sitio/formulario-de-autoexclusion/",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#B0D9BA",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#F2D22D",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  18: {
    success: "#00C975",
    backgroundLight: "#f0feff",
    primary: "#3b9fa7",
    secondary: "#3b9fa7",
    button: {
      primary: "#D7412A",
      secondary: "#fff",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#3b9fa7",
        secondary: "#3b9fa7",
        primary: "#fff",
      },
      hover: {
        primary: "#ff7560",
        secondary: "#eeeded",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#4ad2dd",
    hoverSecondary: "",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "",
    info: {
      titulo: "La Jujeñita Online",
      shortName: "lajujeñitaonline",
      canonical: "https://www.lajujeñitaonline.bet.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "",
      numeroWhatsapp: "54 9 3885 09-5085",
      telefono: "0800-444-1550",
      mail: "contacto@lajujeñitaonline.bet.ar",
      dias: "Lunes a Viernes: 10:00hs a 20:00hs.",
      diasFinde: "Sabado de 9 a 21hs y Domimgo de 9:30 a 15hs.",
      juegoResponsable: "https://inprojuy.gob.ar/#/juegoResponsable",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  20: {
    success: "#00C975",
    backgroundLight: "#fff4f4",
    primary: "#a32c32",
    secondary: "#ee7511",
    button: {
      primary: "",
      secondary: "",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#eb424a",
    hoverSecondary: "",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "#feee00",
    info: {
      titulo: "Loteria de Corrientes Online",
      shortName: "loteriadecorrientesonline",
      canonical: "https://www.lacorrentinaonline.bet.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion:
        "Instituto de Lotería y Casinos de Corrientes - Cordoba 915 - CP W3400CDM - (379) 4476213 - Corrientes, Argentina",
      numeroWhatsapp: "(379) 442-9588 / (379) 447-6229 ",
      mail: "contacto@lacorrentinaonline.com.ar",
      dias: "Lunes a Sábados: 08:00 a 13:00hs y de 16:00 a 20:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  23: {
    success: "#00C975",
    backgroundLight: "#f9f4fe",
    primary: "#5601b7",
    secondary: "#5601b7",
    button: {
      primary: "#A353FF",
      secondary: "#fff",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "#9041eb",
        secondary: "#eeeded",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#6750A4",
    hoverPrimary: "#9041eb",
    hoverSecondary: "#9041eb",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "#5601b7",
    info: {
      titulo: "Loteria de Salta Online",
      shortName: "loteriadesalta",
      canonical: "https://www.loteriadesaltaonline.com.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "Balcarce 759, Salta",
      numeroWhatsapp: "3876029474",
      mail: "contacto@loteriadesaltaonline.com.ar",
      dias: "Lunes a Viernes: 08:00hs a 17:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "0800-555-8346",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  40: {
    success: "#00C975",
    backgroundLight: "#fbeeff",
    primary: "#600080",
    secondary: "#600080",
    button: {
      primary: "#8a77b9",
      secondary: "#f2f2f2",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#8a77b9",
        primary: "#fff",
      },
      hover: {
        primary: "#433465",
        secondary: "#fff",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#b024de",
    hoverSecondary: "",
    gradiente1Llamador: "#600080",
    gradiente2Llamador: "#600080",
    fondoLlamador: "",
    info: {
      titulo: "Loteria de Tierra Del Fuego Online",
      shortName: "loteriadetierradelfuego",
      canonical: "https://loteriadetdf.bet.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "",
      numeroWhatsapp: "",
      mail: "",
      dias: "",
      juegoResponsable: "https://www.ipra.gov.ar/web/juegoresponsable/",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#8E80BF",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#D97C28",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  41: {
    success: "#00C975",
    backgroundLight: "#eaf3ff",
    primary: "#0046ac",
    secondary: "#0046ac",
    button: {
      primary: "",
      secondary: "",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#256cd3",
    hoverSecondary: "",
    gradiente1Llamador: "#edf1f5",
    gradiente2Llamador: "#edf1f5",
    fondoLlamador: "",
    info: {
      titulo: "Loteria de Santa Cruz Online",
      shortName: "loteriadesantacruz",
      canonical: "https://sc.lotline.com.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "Perito Moreno esquina Zapiola, Río Gallegos",
      numeroWhatsapp: "2966-631277",
      mail: "contacto@lotline.com.ar",
      dias: "Lunes a Viernes: 10:00hs a 20:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  42: {
    success: "#00C975",
    backgroundLight: "#fffbe9",
    primary: "#ffcc00",
    secondary: "#ffcc00",
    button: {
      primary: "#06C124",
      secondary: "#ffffff",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "#06C124",
        secondary: "#ffffff",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#000000",
    textSecondary: "#000000",
    hoverPrimary: "#f7d341",
    hoverSecondary: "",
    gradiente1Llamador: "#ffeea1",
    gradiente2Llamador: "#2122411f",
    fondoLlamador: "#ffcc00",
    info: {
      titulo: "La Neuquina Online",
      shortName: "laneuquinaonline",
      canonical: "https://www.laneuquinaonline.com.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "Carlos H. Rodríguez 146, Neuquén",
      telefono: "299 4576784",
      mail: "contacto@laneuquinaonline.bet.ar",
      dias: "Lunes a Sábados: 08:00hs a 22:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "",
    },
    color: {
       0: {
        // Quiniela tradicional
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      1: {
        // Quiniela Instantánea
        colorFrom: "#ffcc00",
        colorTo: "#FFFFFF",
      },
      4: {
        // Quini 6
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      3: {
        // Loto Plus
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      6: {
        // Pozo de la Quiniela
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      10: {
        // Lotería Unificada
        colorFrom: "#ffcc00",
        colorTo: "#FFFFFF",
      },
      20: {
        // Patagonia Minibingo
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
      21: {
        // Patagonia Telebingo
        colorFrom: "#ffcc00",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#ffcc00", 
        colorTo: "#FFFFFF",
      },
    },
  },
  43: {
    success: "#00C975",
    backgroundLight: "#eefff6",
    primary: "#01c160",
    secondary: "#01c160",
    button: {
      primary: "",
      secondary: "",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#2bde84",
    hoverSecondary: "",
    gradiente1Llamador: "#aeaeef",
    gradiente2Llamador: "#5e5ef7",
    fondoLlamador: "#19193a",
    info: {
      titulo: "La Rionegrina Online",
      shortName: "larionegrinaonline",
      canonical: "https://www.loteriadesaltaonline.com.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion:
        "Sede Central: 25 de Mayo y Sarmiento (8500) - Viedma - Río Negro",
      numeroWhatsapp: "2920-487001",
      mail: "contacto@larionegrinaonline.com.ar",
      dias: "Lunes a Viernes: 10:00hs a 20:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  45: {
    success: "#00C975",
    backgroundLight: "#f2f7ff",
    primary: "#1C3257",
    secondary: "#90b228",
    button: {
      primary: "#90b228",
      secondary: "#fff",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#1C3257",
        secondary: "#1C3257",
        primary: "#fff",
      },
      hover: {
        primary: "#c2e84f",
        secondary: "#eeeded",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#3b69b8",
    hoverSecondary: "",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "",
    info: {
      titulo: "Loteria de Catamarca Online",
      shortName: "loteriadecatamarcaonline",
      canonical: "https://www.loteriadecatamarcaonline.bet.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "",
      numeroWhatsapp: "",
      telefono: "",
      mail: "",
      dias: "",
      diasFinde: "",
      juegoResponsable: "https://portal.catamarca.gob.ar/paginas/juego-responsable-524",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#A0BF53",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#1C3257",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  46: {
    success: "#00C975",
    backgroundLight: "#e9fff9",
    primary: "#27594B",
    secondary: "#1CA63F",
    button: {
      primary: "#b0d9ba",
      secondary: "#f4f0d8",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#27594B",
        primary: "#000000",
      },
      hover: {
        primary: "#1ca63f",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#38d35f",
    hoverSecondary: "",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "",
    info: {
      numeroWhatsapp: "54 9 3885 09-5085",
      telefono: "0800-444-1550",
      mail: "contacto@ajalar.bet.ar",
      dias: "Lunes a Viernes: 10:00hs a 20:00hs.",
      diasFinde: "Sabado de 9 a 21hs y Domimgo de 9:30 a 15hs.",
      juegoResponsable: "https://ajalar.com.ar/sitio/",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#B0D9BA",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#F2D22D",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  48: {
    success: "#00C975",
    backgroundLight: "#f0feff",
    primary: "#3b9fa7",
    secondary: "#3b9fa7",
    button: {
      primary: "#D7412A",
      secondary: "#fff",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#3b9fa7",
        secondary: "#3b9fa7",
        primary: "#fff",
      },
      hover: {
        primary: "#ff7560",
        secondary: "#eeeded",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#4ad2dd",
    hoverSecondary: "",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "",
    info: {
      titulo: "La Jujeñita Online",
      shortName: "lajujeñitaonline",
      canonical: "https://www.lajujeñitaonline.bet.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "",
      numeroWhatsapp: "54 9 3885 09-5085",
      telefono: "0800-444-1550",
      mail: "contacto@lajujeñitaonline.bet.ar",
      dias: "Lunes a Viernes: 10:00hs a 20:00hs.",
      diasFinde: "Sabado de 9 a 21hs y Domimgo de 9:30 a 15hs.",
      juegoResponsable: "https://inprojuy.gob.ar/#/juegoResponsable",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  50: {
    success: "#00C975",
    backgroundLight: "#fff4f4",
    primary: "#a32c32",
    secondary: "#ee7511",
    button: {
      primary: "",
      secondary: "",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#FFFFFF",
    hoverPrimary: "#eb424a",
    hoverSecondary: "",
    gradiente1Llamador: "#feee0073",
    gradiente2Llamador: "#02020257",
    fondoLlamador: "#feee00",
    info: {
      titulo: "Loteria de Corrientes Online",
      shortName: "loteriadecorrientesonline",
      canonical: "https://www.lacorrentinaonline.bet.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion:
        "Instituto de Lotería y Casinos de Corrientes - Cordoba 915 - CP W3400CDM - (379) 4476213 - Corrientes, Argentina",
      numeroWhatsapp: "(379) 442-9588 / (379) 447-6229 ",
      mail: "contacto@lacorrentinaonline.com.ar",
      dias: "Lunes a Sábados: 08:00 a 13:00hs y de 16:00 a 20:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
  53: {
    success: "#00C975",
    backgroundLight: "#f9f4fe",
    primary: "#5601b7",
    secondary: "#5601b7",
    button: {
      primary: "#A353FF",
      secondary: "#fff",
      success: "#08E12B",
      danger: "#DC2D14",
      light: "#fff",
      text: {
        success: "#fff",
        danger: "#fff",
        light: "#6750A4",
        secondary: "#6750A4",
        primary: "#fff",
      },
      hover: {
        primary: "#9041eb",
        secondary: "",
        success: "#06C124",
        danger: "#B82410",
        light: "#eeeded",
      }
    },
    textPrimary: "#FFFFFF",
    textSecondary: "#6750A4",
    hoverPrimary: "#9041eb",
    hoverSecondary: "#9041eb",
    gradiente1Llamador: "transparent",
    gradiente2Llamador: "transparent",
    fondoLlamador: "#5601b7",
    info: {
      titulo: "Loteria de Salta Online",
      shortName: "loteriadesalta",
      canonical: "https://www.loteriadesaltaonline.com.ar/plataforma/",
      manifest: "manifest.webmanifest",
      direccion: "Balcarce 759, Salta",
      numeroWhatsapp: "3876029474",
      mail: "contacto@loteriadesaltaonline.com.ar",
      dias: "Lunes a Viernes: 08:00hs a 17:00hs.",
      juegoResponsable: "",
      telJuegoResponsable: "0800-555-8346",
    },
    color: {
      0: {
        colorFrom: "#EC184B",
        colorTo: "#FFFFFF",
      },
      1: {
        colorFrom: "#00AEEE",
        colorTo: "#FFFFFF",
      },
      4: {
        colorFrom: "#FAE91E",
        colorTo: "#FFFFFF",
      },
      3: {
        colorFrom: "#5601B6",
        colorTo: "#FFFFFF",
      },
      raspadita: {
        colorFrom: "#000000",
        colorTo: "#FFFFFF",
      },
    },
  },
};
